<div class="clock-widget {{breakType}}-break" (click)="openPunchWidget()" [class.isPunched]="(punchedIn$ | async)">
	<div class="middle-bar {{breakType}}-break">
		<div class="clock-block">
			<mat-icon class="icon-clock">
				access_time
			</mat-icon>
		</div>
		<div class="total-time-block" *ngIf="(trackWorkTime$ | async)">
			<div class="total-block">
				<!-- <div style="margin-bottom: 1px; padding-right: 3px;">TOTAL: </div> -->
				<div class="time-div">{{totalTime}}</div>

			</div>
		</div>
	</div>
</div>